import { ITranslations } from 'types/common';
import { CataloguesRequestsTableTransFields } from './types';
import en from 'translations/en/cataloguesRequestsTable.json';
import pl from 'translations/pl/cataloguesRequestsTable.json';
import sl from 'translations/sl/cataloguesRequestsTable.json';

export const cataloguesRequestsTableTranslations: ITranslations<CataloguesRequestsTableTransFields> = {
  name: 'cataloguesRequestsTable',
  en,
  pl,
  sl,
};
